import { default_get, 
    default_post 
} from "../requests";

export function getCenterInfo(_center) {
    return default_get(`/paas/center?id=${String(_center).toUpperCase()}`)
}

export function editDescriptionPaasCenter(description) {
    return default_post({ description }, '/paas/center/description')
}

export function publicSolution(solution_id) {
    return default_post({ id: solution_id }, '/paas/center/addSolution')
}

export function editPaasSolutionCenter(salas, turmas) {
    return default_post({ salas, turmas }, '/paas/center/editSolution')
}

export function toggleStatusPaasCenter() {
    return default_post({ }, '/paas/center/toggleStatus')
}

